import styled from '@emotion/styled';
import { ReactNode } from 'react';
import { Video } from '../../utils/api/videoApi';
import { getStreamingSrc, VIDEO_ORIENTATIONS } from '../../utils/helpers/video';
import {
  breakpoints,
  colors,
  DESKTOP_SECTION_FIXED_HEIGHT_CSS,
  spacing,
} from '../../utils/styleguide';
import { Col, Row } from './layout/12ColGridLayout';
import BackgroundVideo from './page-sections/BackgroundVideo';

const Section = styled.section`
  background-color: ${colors.black};
  height: 100vh;
  ${DESKTOP_SECTION_FIXED_HEIGHT_CSS}
`;

const Content = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const DescriptionWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${spacing[4]}px;
  ${breakpoints.desktop} {
    margin-top: ${spacing[6]}px;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${spacing[6]}px;
  ${breakpoints.desktop} {
    margin-top: ${spacing[10]}px;
  }
`;

type Props = {
  portraitBackgroundVideo: Video;
  landscapeBackgroundVideo: Video;
  Title: ReactNode;
  Description?: ReactNode;
  Button?: ReactNode;
};

const HeadlinerVideo = ({
  portraitBackgroundVideo,
  landscapeBackgroundVideo,
  Title,
  Description,
  Button,
}: Props) => {
  return (
    <Section>
      <BackgroundVideo
        videoLargeScreenUrl={getStreamingSrc({
          video: landscapeBackgroundVideo,
          orientation: VIDEO_ORIENTATIONS.LANDSCAPE,
        })}
        videoSmallScreenUrl={getStreamingSrc({
          video: portraitBackgroundVideo,
          orientation: VIDEO_ORIENTATIONS.PORTRAIT,
        })}
        posterLargeScreenUrl={landscapeBackgroundVideo.metaData?.posterSrc}
        posterSmallScreenUrl={portraitBackgroundVideo.metaData?.posterSrc}
        aspectRatios={{ desktop: 0, tablet: 0, mobile: 0 }}
        showControls={false}
        hasOverlay
        hlsConfig={{
          capLevelToPlayerSize: false,
        }}
      >
        <Content>
          <Row>
            {Title && <Col>{Title}</Col>}
            {Description && (
              <Col tablet="3 / span 8">
                <DescriptionWrapper>{Description}</DescriptionWrapper>
              </Col>
            )}
            {Button && (
              <Col>
                <ButtonWrapper>{Button}</ButtonWrapper>
              </Col>
            )}
          </Row>
        </Content>
      </BackgroundVideo>
    </Section>
  );
};

export default HeadlinerVideo;
